import './styles/megamenu.scss'
function getMenu() {
    const menuList = [ 'top', 'about','business', 'responsibilities', 'careers', 'press', 'ir']
    return menuList.map((item) => {
        return {
            name: item,
            btn : document.getElementById(`js-menu-${item}`),
            panel: document.getElementById(`js-megamenu-${item}`)
        }
    })
}

function initMegaMenu() {
    const html = document.querySelector('html')
    const megaMenu = document.getElementById('js-megamenu')
    const megaMenuPanel = document.querySelector('.l-header-megamenu__panel')

    for(const item of getMenu()) {
        console.log(item)
        item.btn.addEventListener('mouseenter', function() {
            if(item.panel) {
                const megaMenuHeight = 150
                html.classList.add("is-megamenu--opened");
                megaMenuPanel.id = `js-active-${item.name}`
                megaMenu.style.height = `${megaMenuHeight + item.panel.getBoundingClientRect().height}px`;
            } else {
                html.classList.remove("is-megamenu--opened");
                if(html.classList.contains("is-scrolled")) {
                    megaMenu.style.height = ''
                } else {
                    megaMenu.style.height = ''
                }
            }
        }, false)
    }
    megaMenu.addEventListener('mouseleave', function() {
        html.classList.remove("is-megamenu--opened");
        if(html.classList.contains("is-scrolled")) {
            megaMenu.style.height = ''
        } else {
            megaMenu.style.height = ''
        }
    }, false)
}

function currentMenu() {
    const navi = location.pathname.split('/').find((item) => {
         return menuList.find((menu) => {
            return menu === item
        })
    })
    document.getElementById(`js-menu-${navi}`).classList.add('is-current')
}

document.addEventListener('DOMContentLoaded', initMegaMenu)
// document.addEventListener('DOMContentLoaded', currentMenu)